<template>
<Card :padding="0" :bordered="myConfig.bordered" :dis-hover="myConfig.disHover" :headClass="headClass" :extraClass="extraClass">
    <p v-if="showTitle" slot="title" :style="pStyle" @click="toggle" >
        <span :class="titleClass" v-text="myConfig.title" /> <Icon v-if="myConfig.hide" class="efuture-title-icon" :style="iconStyle" type='ios-arrow-forward'/> 
    </p>
    <div v-show="showGrid" :style="cardStyle" >
         <ViewGrid ref="grid" :config="myConfig"></ViewGrid>
    </div>
</Card>
</template>
<script>
export default {
    name: 'operlog',
    data () {
        return {
            myConfig:{
                hide:true,
                headStyle:'',
                titleType:1,
                dynamicHeight:true,
                bordered:true,   
                disHover:false,
                method:'excelimperrsrv.search',
                searchParam:{
                },
                response:'imperrmsg',
                title:'导入错误日志',
                height:2500,
                items:[{
                    label:'错误信息',
                    name:'errmsg',
                    type:'TextBox'
                }]
            },
            cardPadding:0,
            cardStyle:'',
            showGrid:true,
            showTitle:true,
            pStyle:'',
            iconStyle:'',
            seqno:''
        };
    },
    created() {
        this.myConfig = Object.assign({},this.myConfig, this.config);
        this.myConfig.tableSize = 'small';
        this.myConfig.showBorder = false;
        // 处理模块号提示
        let modulecode = this.$Method.getUrlParam('modulecode');
        if (!modulecode) {
            modulecode = this.$Method.getUrlParam('billmoduleid');
        }
        if (this.modulecode) {
            modulecode = this.modulecode;
        }
       
        this.myConfig.searchParam.moduleid = modulecode;
        this.myConfig.refurbishCheck = this.refurbishCheck;
        this.customInit ();
        if (!this.myConfig.hide) {
            this.setShowGrid(true);
        }
        this.setTitleStyle();
    },
    computed: {
        titleClass () {
            return `efuture-title-font-${this.myConfig.titleType}`;
        },
        headClass () {
            return `efuture-card-head-title-${this.myConfig.titleType}`;
        },
        extraClass () {
            return `efuture-card-extra-title-${this.myConfig.titleType}`;
        }
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        modulecode: {
            type:String,
            default:null
        }
    },
    methods: {
        customInit() {
            if (this.myConfig.hide) {
                this.pStyle = 'cursor:pointer';
                this.iconStyle = 'transform: rotate(90deg)';
            } 
            this.cardPadding = 5 * Number(this.myConfig.titleType);
            this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px;';
        },
        toggle () {
            if (this.myConfig.hide) {
                this.showGrid = !this.showGrid;
                this.setTitleStyle();
            }
        },
        setShowGrid(value) {
            this.showGrid = value;
            this.setTitleStyle();
        },
        setTitleStyle () {
            if (this.showGrid) {
                this.iconStyle = 'transform: rotate(90deg)';
                this.cardPadding =  5 * Number(this.myConfig.titleType);
                this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px;';
            } else {
                this.iconStyle = '';
                this.cardPadding  = 0;
                this.cardStyle = '';
            }
        },
        refurbishCheck (para,old,toDo) {
            if (this.seqno) {
                toDo(true,para,old);
            } else {
                toDo(false,para,old);
            }
        },
        refurbish (value) {
            if (value) {
                let para = {};
                para.seqno = value;
                this.seqno = value;
                this.$refs.grid.clearSearchBeforeSearchParam();
                this.$refs.grid.setSearchBeforeSearchParam(para);
                this.$refs.grid.refurbish();
            } else {
                this.seqno = '';
                this.$refs.grid.clearSearchBeforeSearchParam();
                this.$refs.grid.clearData();
            }
        },
        clearData () {
            this.$refs.grid.clearData();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/importlog.vue